<div class="px-3">
  <div class="rem-text-default mb-6">
    <div class="flex align-items-center">
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-users font-medium text-xl"></i>
      </div>
        <div>
          <div class="text-2xl font-medium">VMDrop Configuration</div>
          <div class="text-right mt-2"></div>
        </div>
    </div>
  </div>


  <div class="flex justify-content-between">
    <div class="flex flex-row gap-3 align-items-center">
      <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete>

      <p-floatLabel>
        <p-dropdown class="w-full" id="settlementTypeOptions" [options]="vmDropStatusOptions" [(ngModel)]="filterVmDropStatus" (onChange)="this.getVmDropTableData($event.value)" optionLabel="label" optionValue="id" placeholder="Select Type"></p-dropdown>
        <label for="creditors">Status</label>
      </p-floatLabel>
         
    </div>
   
</div>
<div class="mt-4">
    <p-table *ngIf="hasTableData" [value]="filteredVmDropConfigs" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true"
      [rows]="10" [rowsPerPageOptions]="[10, 20, 30]" >
        <ng-template pTemplate="header">
            <tr class="text-xs">
                <th>Creditor Id</th>
                <th>Creditor Name</th>
                <th>Status</th>         
                <th>Action</th>         
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
            <tr class="text-xs">
                <td>{{ data.CreditorId }}</td>
                <td>{{ data.CompanyName }}</td>
                <td>{{ data.IsVMDropEnabled === 1 ? 'Active' : 'Inactive'}}</td>
                <td>
                    <div class="flex align-items-center gap-2">
                        <icon-button
                        pTooltip="Edit"
                        tooltipPosition='left'
                        (click)="onOpenSideBar({
                          creditorId: data.CreditorId
                        })"
                        [icon]="'pencil'"
                        [styleClass]="'mr-1'"
                       />
                      <p-inputSwitch (ngModelChange)="onChangeStatus(extractId(data.CreditorId), $event)" [ngModel]="data.IsVMDropEnabled === 1" />
                      </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center">No records found for {{ creditorCompanyName }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>

</div>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{isEditMode ? 'Update ' : 'Add '}} VMDrop Config - {{ actionCreditorId }}</div>
      <div class="mt-4" *ngIf="!creditorHasFormData">
        <p-floatLabel>
          <p-autoComplete 
            [suggestions]="filteredCreditors"  
            (completeMethod)="filterCreditors($event)" 
            (onSelect)="onSelectCreditorForForm($event)"
            [dropdown]="true" 
            optionLabel="CompanyName"
            placeholder="Select Creditor"
            id="vmDropEnabledCreditors"
            >
            <ng-template let-vmDropEnabledCreditors pTemplate="item">
              <div class="flex align-items-center justify-content-between flex-1">
                <div>{{vmDropEnabledCreditors.CompanyName}}</div>
                <div>{{vmDropEnabledCreditors.CreditorId}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <label for="vmDropEnabledCreditors">Creditor</label>
        </p-floatLabel>

      </div>
      <form [formGroup]="vmDropForm" (ngSubmit)="onSave()">
        <div class="field mt-4">
          <label for="PoolId" class="block mb-2">Pool ID</label>
          <input id="PoolId" type="text" pInputText class="w-full" formControlName="PoolId"/>
        </div>

        <div class="field mt-4">
          <label for="BrandId" class="block mb-2">Brand ID<span class="text-red-500">*</span></label>
          <input id="BrandId" type="text" pInputText class="w-full" formControlName="BrandId"
            [ngClass]="{'p-invalid': vmDropForm.get('BrandId')?.invalid && (vmDropForm.get('BrandId')?.touched || isSubmitted)}"
          />
          <div *ngIf="vmDropForm.get('BrandId')?.invalid && (vmDropForm.get('BrandId')?.touched || isSubmitted)" class="text-red-500 text-sm mt-1">
            Brand ID is required.
          </div>
        </div>

        <div class="field mt-4">
          <label for="CallerId" class="block mb-2">Caller ID</label>
          <input id="CallerId" type="text" pInputText class="w-full" formControlName="CallerId"/>
        </div>

        <div class="field mt-4">
          <label for="TeamId" class="block mb-2">Team ID</label>
          <input id="TeamId" type="text" pInputText class="w-full" formControlName="TeamId"/>
        </div>

        <div class="field mt-4">
          <label for="BaseUrl" class="block mb-2">Base URL<span class="text-red-500">*</span></label>
          <input id="BaseUrl" type="text" pInputText class="w-full" formControlName="BaseUrl"
            [ngClass]="{'p-invalid': vmDropForm.get('BaseUrl')?.invalid && (vmDropForm.get('BaseUrl')?.touched || isSubmitted)}"
          />
          <div *ngIf="vmDropForm.get('BaseUrl')?.invalid && (vmDropForm.get('BaseUrl')?.touched || isSubmitted)" class="text-red-500 text-sm mt-1">
            Base URL is required.
          </div>
        </div>

        <div class="field mt-4">
          <label for="SecretId" class="block mb-2">Secret ID</label>
          <input id="SecretId" type="text" pInputText class="w-full" formControlName="SecretId"/>
        </div>

        <div class="field mt-4">
          <label for="VoiceMaleId" class="block mb-2">Voice Male ID</label>
          <input id="VoiceMaleId" type="text" pInputText class="w-full" formControlName="VoiceMaleId"/>
        </div>

        <div class="field mt-4">
          <label for="VoiceFemaleId" class="block mb-2">Voice Female ID</label>
          <input id="VoiceFemaleId" type="text" pInputText class="w-full" formControlName="VoiceFemaleId"/>
        </div>

        <div class="flex justify-content-end mt-4">
          <remitter-button
            [label]='isEditMode ? "Update" : "Save"'
            icon='send'
          >     
          </remitter-button>
        </div>

      </form>
    </div>
  </p-sidebar>
